// src/features/bookings/components/BookingForm/cards/LegacyGeneralInfoCard.jsx
import React from 'react';
import styles from '../../../../../components/Form.module.css';

function LegacyGeneralInfoCard({ bookingData, handleBookingChange }) {
  return (
    <fieldset className={styles.fieldset}>
      <legend className={styles.legend}>معلومات الحجز العامة</legend>
      <div className={styles.inputGrid}>
        <div className={styles.inputGroup}>
          <label className={styles.formLabel}>موقع التصوير</label>
          <input
            type="text"
            name="shooting_location"
            value={bookingData.shooting_location}
            onChange={handleBookingChange}
          />
        </div>
        <div className={styles.inputGroup}>
          <label className={styles.formLabel}>وقت التصوير</label>
          <input
            type="time"
            name="shooting_time"
            value={bookingData.shooting_time}
            onChange={handleBookingChange}
          />
        </div>
      </div>
      <div className={styles.inputGroup} style={{ marginTop: '15px' }}>
        <label className={styles.formLabel}>ملاحظات عامة</label>
        <textarea
          name="notes"
          value={bookingData.notes}
          onChange={handleBookingChange}
          rows="3"
        />
      </div>
    </fieldset>
  );
}

export default LegacyGeneralInfoCard;